import { FC, useMemo } from "react";
import { EmptySubtitle, EmptyTitle, OptionsEmptyWrapper, OptionsIconWrapper } from "./style";
import { FlexBox, RectangularButtonFilled, RectangularButtonHollow, useBreakpoint } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { FolderT } from "../../tabs/const";
import { PinIcon } from "../icons/pin";
import { EditIcon } from "../icons/edit";
import { ProfileFoldersProps } from "shared/reducers/ProfileFoldersSlice";
import { LayoutConst } from "core";


export const FolderEmptyOptions: FC<{
    isMe: boolean,
    activeFolder?: FolderT, 
    onAdd: () => void
    onDelete: () => void 
}> = ({ 
    isMe,
    activeFolder, 
    onAdd,
    onDelete 
}) => {
    const { t } = useTranslation();
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1);

    return (
        <OptionsEmptyWrapper gx={24} gy={40} offsetTop={24} direction="column">
            <FlexBox direction="column" gy={16} align="center" justify={'center'}>
                <EmptyTitle>{t('folders.modal.empty_modal_title')}</EmptyTitle>
                {isMe && <EmptySubtitle>{t('folders.modal.empty_modal_subtitle', { name: activeFolder?.name })}</EmptySubtitle>}
            </FlexBox>
            {isMe && (
                <FlexBox gx={24} direction="row" directionMobile={isMobile ? 'column' : 'row'} gxMobile={isMobile ? 1 : 24} gyMobile={isMobile ? 8 : 1}>
                    <RectangularButtonHollow onClick={onDelete}>
                        {t('folders.edit.delete_more')}
                    </RectangularButtonHollow>
                    <RectangularButtonFilled onClick={onAdd}>
                        {t('folders.edit.choose_projects')}
                    </RectangularButtonFilled>
                </FlexBox>
            )}

        </OptionsEmptyWrapper>
    )
}import { FC, useMemo } from "react";
import { EmptySubtitle, EmptyTitle, OptionsEmptyWrapper, OptionsIconWrapper } from "./style";
import { FlexBox, RectangularButtonFilled, RectangularButtonHollow, useBreakpoint } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { FolderT } from "../../tabs/const";
import { PinIcon } from "../icons/pin";
import { EditIcon } from "../icons/edit";
import { ProfileFoldersProps } from "shared/reducers/ProfileFoldersSlice";
import { LayoutConst } from "core";


export const FolderEmptyOptions: FC<{
    isMe: boolean,
    activeFolder?: FolderT, 
    onAdd: () => void
    onDelete: () => void 
}> = ({ 
    isMe,
    activeFolder, 
    onAdd,
    onDelete 
}) => {
    const { t } = useTranslation();
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1);

    return (
        <OptionsEmptyWrapper gx={24} gy={40} offsetTop={24} direction="column">
            <FlexBox direction="column" gy={16} align="center" justify={'center'}>
                <EmptyTitle>{t('folders.modal.empty_modal_title')}</EmptyTitle>
                {isMe && <EmptySubtitle>{t('folders.modal.empty_modal_subtitle', { name: activeFolder?.name })}</EmptySubtitle>}
            </FlexBox>
            {isMe && (
                <FlexBox gx={24} direction="row" directionMobile={isMobile ? 'column' : 'row'} gxMobile={isMobile ? 1 : 24} gyMobile={isMobile ? 8 : 1}>
                    <RectangularButtonHollow onClick={onDelete}>
                        {t('folders.edit.delete_more')}
                    </RectangularButtonHollow>
                    <RectangularButtonFilled onClick={onAdd}>
                        {t('folders.edit.choose_projects')}
                    </RectangularButtonFilled>
                </FlexBox>
            )}

        </OptionsEmptyWrapper>
    )
}